export default __webpack_public_path__ + "static/media/weaning.d4948c2c.png";